import { renderAttachmentLabels } from './context';

export function appendMessageAttachments(bubble: Element | null, attachments: unknown[] = []): void {
  if (!bubble || !Array.isArray(attachments) || attachments.length === 0) return;
  bubble.insertAdjacentHTML('beforeend', renderAttachmentLabels(attachments));
}
